import {Select} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import tagFetcherHoc from "@hocs/tagFetcherHoc";
import {Tag} from "@models/tag";


const Option = Select.Option;


export interface TagMultiSelectionReturnValue {
  new_tags: string[];
  deleted_tags: string[];
  selectedItems: Tag[]
}

export const tagMultiSelectionDefaultReturnValue: TagMultiSelectionReturnValue = {
  new_tags: [],
  deleted_tags: [],
  selectedItems: []
};

type TagSelectionProps = {
  mode: SelectionMode,
  onChange: (value: TagMultiSelectionReturnValue) => void
  selectedTags: Tag[],
  data: Tag[],
  onScroll: (e: SyntheticEvent) => void,
  handleSearch: (query: string) => void,
  fetchData: (params: object | null) => void,
  filter?: object,
  isFetched: boolean,
  initialValue: Tag[] | Tag | null,
  isDuplicatedForm?: boolean
}


/**
 * This class handle selection of tags
 * Use Select fro ant-design because it has on scroll option
 * In terms of lazy loading of data, selected items should bre rendered separated
 * On Change callback return an object from new and deleted tags
 * @param props
 * @constructor
 */
const TagsSelection: React.FC<TagSelectionProps> = props => {
  const {handleSearch, onScroll, data = [], initialValue, onChange, fetchData, isFetched, mode = SelectionMode.DEFAULT , isDuplicatedForm} = props;
  const defaultValue = mode == SelectionMode.MULTIPLE ? [] : null;
  
  const retrieveValueFromProps = () => {
    if (mode == SelectionMode.MULTIPLE) {
      const returnValue = props.initialValue || [];
      return returnValue.map(item => item.id)
    }
    else {
      return props.initialValue ? props.initialValue.id : null
    }
  };
  
  const [value, setValue] = useState(initialValue ? retrieveValueFromProps() : defaultValue);
  
  useEffect(() => {
    const value = retrieveValueFromProps();
    setValue(value);
  }, [props.initialValue]);
  
  
  /**
   * To handle show selected tags before fetch data
   */
  const getData = () => {
    if (mode == SelectionMode.MULTIPLE) {
      let returnData = data;
      const selectedValues = props.initialValue || [];
      selectedValues.forEach(tag => {
        if (returnData.findIndex(opt => opt.id === tag.id) === -1) {
          returnData.push(tag)
        }
      });
      
      return returnData;
    }
    else {
      return initialValue && !data.find(opt => opt.id == initialValue.id) ? [...data, initialValue] : data;
    }
  };
  
  const onChangeValue = (newValue, option) => {
    setValue(newValue);
    if (mode == SelectionMode.MULTIPLE) {
      const selectedValues = props.initialValue || [];
      const oldValue = selectedValues.map(cat => cat.id);
      const deleted_tags = oldValue.filter(item => newValue.findIndex(id => id === item) === -1);
      const new_tags = isDuplicatedForm ? newValue : newValue.filter(item => oldValue.findIndex(id => id === item) === -1);
          
      props.onChange({
        deleted_tags,
        new_tags,
        selectedItems: option.map(opt => opt.props.tag)
      });
    }
    else {
      onChange(option.props.tag)
    }
  };
  
  const onFocus = () => {
    if (isFetched == false) {
      fetchData({});
    }
  };
  
  return (
    <Select
      showSearch
      mode={mode}
      value={value}
      defaultActiveFirstOption={false}
      showArrow={true}
      filterOption={false}
      onChange={onChangeValue}
      onFocus={onFocus}
      onSearch={handleSearch}
      onPopupScroll={onScroll}
      notFoundContent={null}
    >
      {getData().map(tag =>
        <Option key={tag.id} tag={tag}>{tag.title}</Option>
      )}
    </Select>
  );
};

export default tagFetcherHoc(TagsSelection);


